import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { FileDown } from "lucide-react";
 * // Use <FileDown /> instead
 */
export const FileExportIcon = createSVGWrapper(
  <>
    <path
      fill="currentColor"
      d="M4 21h11a1 1 0 0 0 1-1v-2h-4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h4V7.414a1 1 0 0 0-.293-.707l-3.414-3.414A1 1 0 0 0 11.586 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1Z"
    />
    <path fill="currentColor" d="M18 19v-3h-6v-3h6v-3l5 4.5-5 4.5Z" />
  </>
);
